export default "__VITE_ASSET__DnBSBJhd__"